export const DATA_REFRESHED_EVENT = "horosho:data-refresh";
